


import { Routes, RouterModule } from '@angular/router';
import { TableInfoComponent } from './tableinfo.component';

const routes: Routes = [
    {
        path: '',
        component: TableInfoComponent
    },
];

export const TableInfoRoutes = RouterModule.forChild(routes);
